'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function wixElementWrapper(services) {
    var WixElement = function (_HTMLElement) {
        _inherits(WixElement, _HTMLElement);

        function WixElement() {
            _classCallCheck(this, WixElement);

            // eslint-disable-line no-useless-constructor
            return _possibleConstructorReturn(this, _HTMLElement.call(this));
        }

        WixElement.prototype.reLayout = function reLayout() {
            //should be implemented inside child element
        };

        WixElement.prototype.connectedCallback = function connectedCallback() {
            services.resizeService.observe(this);
            this.reLayout();
        };

        WixElement.prototype.disconnectedCallback = function disconnectedCallback() {
            services.resizeService.unobserve(this);
        };

        return WixElement;
    }(HTMLElement);

    return WixElement;
}

module.exports = wixElementWrapper;
//# sourceMappingURL=wixElement.js.map